import React from 'react';
import './Hero.css';

const Hero = () => {
  return (
    <div className="hero-container">
      <div className="hero-content">
        <h1 className="hero-title">Invest with Confidence</h1>
        <p className="hero-subtitle">
          Track, analyze, and manage your stock portfolio with real-time data and advanced analytics.
        </p>
        <div className="hero-buttons">
          <button className="btn-primary">Get Started</button>
          <button className="btn-secondary">Learn More</button>
        </div>
      </div>
      <div className="hero-image">
         <img src="media/images/homeHero.png" alt="Hero" className="mb-5" />
      </div>
    </div>
  );
};

export default Hero;
